<template>
    <div class="colorcard" v-if="colorSetting">
        <div class="colorbar-1 colorbar">
            <div v-if="colorBlock1&&colorBlock1.tipsArray" class="colorbar-tip-wrap" :style="{height:colorBlock1.height+'px'}">
                <div v-for="(item,index) in colorBlock1.tipsArray" :key="index" class="colorbar-tip" :style="item.style">
                    {{item.value}}
                </div>
            </div>
            <div v-if="colorBlock1&&colorBlock1.colorArray" class="color-wrap">
                <div :style="{height:colorBlock1.itemHeight+'px',background:item}"  v-for="(item,index) in colorBlock1.colorArray"  class="colorbar-item" :key="index" :data-value="colorBlock1.numbers[index]">
                </div>
            </div>
        </div>
        
        <div class="colorbar-2 colorbar">
             <div v-if="colorBlock2&&colorBlock2.tipsArray" class="colorbar-tip-wrap" :style="{height:colorBlock2.height+'px'}">
                <div v-for="(item,index) in colorBlock2.tipsArray" :key="index" class="colorbar-tip" :style="item.style">
                    {{item.value}}
                </div>
            </div>
            <div v-if="currentColorSettings&&currentColorSettings.colorPiece==2" class="color-wrap">
                <div :style="{height:colorBlock2.itemHeight+'px',background:item}" class="colorbar-item" 
                    v-for="(item,index) in colorBlock2.colorArray" :key="index" :data-value="colorBlock2.numbers[index]">
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import GradientColor from "./GradientColor";
/**
 * 颜色色卡
 */
export default {
    name:"colorcard",
    props:["colorSetting"],
    data(){
        return {
            /**
             * [
             *  {
             *      value:10 , // 数值
             *      rgb:rgb(0,0,0) // 颜色值
             *  }
             * ]
             */
            colorArray:[], // 第一段颜色卡配置
            colorArray2:[], // 第二段颜色卡配置

            currentColorSettings:null, // 当前颜色卡的配置
        }
    },
    
    mounted(){
        this.$nextTick(()=>{
            // 初始化色卡
            this.creatColorsArray(this.colorSetting);
        });
    },
    computed:{
        // 颜色段一的配置
        colorBlock1(){
            return this.currentColorSettings&&this.currentColorSettings.colorBlock[0]?this.currentColorSettings.colorBlock[0]:null;
        },
        // 颜色段二的配置
        colorBlock2(){
            return this.currentColorSettings&&this.currentColorSettings.colorBlock[1]?this.currentColorSettings.colorBlock[1]:null;
        },
    },
    watch:{
        colorSetting:function(newValue){
            this.creatColorsArray(newValue);
        }
    },
    methods:{
        // 初始化颜色分段
        creatColorsArray(colorSetting){
            let colorPiece=colorSetting.colorPiece; // 获取颜色卡段数

            if(colorPiece==1){ // 如果颜色卡分了一段
                let colorBlock=colorSetting.colorBlock[0]; // 颜色段一
                let colorSection=colorBlock.colorSection; //颜色段

                // 获取颜色数组
                let colorArray=this.getRainbowColorArray(colorSection); 
                colorBlock.colorArray=colorArray;

                // 获取颜色对应的文字值
                colorBlock.height=300;
                // 设置提示
                let characterArray=this.calculate_characterValue(colorBlock); 
                colorBlock.numbers=characterArray;

                // 计算提示文字位置
                let tipsArray=this.calculate_tipValue(colorBlock);
                colorBlock.tipsArray=tipsArray;
            }else{ // 如果颜色卡分了两段

                // 颜色段一
                let colorBlock=colorSetting.colorBlock[0]; 
                let colorSection=colorBlock.colorSection; // 分段数

                // 颜色数组
                let colorArray=this.getRainbowColor2Array_own(colorSection); 
                colorBlock.colorArray=colorArray;

                // 颜色卡的高度
                colorBlock.height=150;
                let characterArray=this.calculate_characterValue(colorBlock); // 获取颜色对应的文字值
                colorBlock.numbers=characterArray;

                // 计算提示文字位置
                let tipsArray=this.calculate_tipValue(colorBlock);
                colorBlock.tipsArray=tipsArray;

                // 颜色段二
                colorBlock=colorSetting.colorBlock[1]; 
                colorSection=colorBlock.colorSection; // 分段数
                colorArray=this.getRainbowColor2Array_two(colorSection); // 获取颜色段数
                colorBlock.colorArray=colorArray;

                // 颜色卡的高度
                colorBlock.height=150;  
                characterArray=this.calculate_characterValue(colorBlock); // 获取颜色对应的文字值
                colorBlock.numbers=characterArray;

                // 计算提示文字位置
                tipsArray=this.calculate_tipValue(colorBlock);
                colorBlock.tipsArray=tipsArray;
                
            }
            // 更新当前颜色设置
            this.currentColorSettings=Object.assign({},colorSetting);            
        },
        // 计算颜色条对应的数字
        calculate_characterValue(colorBlock){
            let rgbColors=colorBlock.colorArray; // 颜色数组

            let rgbHeight=colorBlock.height||150; // 颜色条的默认高度
            let itemHeight = rgbHeight / rgbColors.length; // 每一个颜色条的高度
            colorBlock.itemHeight=itemHeight; 

            let numbers=[]; // 颜色对应的数值数组

            //计算提示信息
            let tempCon=""; // 提示内容,也就是颜色对应的数字
            let colorLineType=colorBlock.colorType;//颜色类型
            let colorSize = colorBlock.colorSection; //分段

            let maxValue = colorBlock.upperValue; //上限数据
            let minValue = colorBlock.lowerValue; //下限数据

            let startValue = maxValue; // 开始值
            let endValue=startValue; // 结束值

            for (let i = rgbColors.length-1; i >=0; i--) {
                if (i == rgbColors.length - 1) {
                    tempCon = this.significantDigit(maxValue);
                } else if (i==0) {
                    tempCon = "↓ "+this.significantDigit(minValue);
                } else {
                    var itemVal = this.accDiv(this.accSub(maxValue, minValue), colorSize-2);
                    endValue = this.accSub(startValue, itemVal);
                    if (colorLineType === 0) {
                        tempCon=this.significantDigit(endValue);
                    } else {
                        tempCon=this.significantDigit(endValue);
                    }
                    startValue = this.accSub(startValue, itemVal);
                }
                numbers.push(tempCon);
            }

            return numbers;
            // //计算各个提示文字的位置
            // $(colorItemHtml).find(".colorbar-colrr").each(function (index, item) {
            //     var itemValue=$(item).attr("data-value");
            //     if(index == rgbColors.length - 1){
            //         colorTipHtml+="<div class='colorbar-tip' style='bottom:0px;'>"+itemValue+"</div>";
            //     }else if(index ==0){
            //         colorTipHtml+="<div class='colorbar-tip' style='top:"+itemHeight*index+"px;'>"+itemValue+"</div>";
            //     }else {
            //         if(itemHeight*(index)-21*fontCount>0&&(itemHeight*index<=124)){
            //             colorTipHtml+="<div class='colorbar-tip' style='top:"+itemHeight*index+"px;'>"+itemValue+"</div>";
            //             fontCount=fontCount+1;
            //         }
            //     }
            // });
            // var colorbarHtml="<div class='colorbar-tip-wrap'>"+colorTipHtml+"</div><div class='colorbar-item'>"+colorItemHtml+"</div>";
            // $("#show-rgb2 .colorbar-2").append(colorbarHtml);
        },
        // 计算提示条的位置
        calculate_tipValue(colorBlock){
            let numbers=colorBlock.numbers; // 文字提示
            let itemHeight=colorBlock.itemHeight;
            let tipsArray=[]; //提示文字数组

            let height=colorBlock.height;
            if(colorBlock.height==300){
                height=276;
            }else{
                height=124;
            }

            // 遍历所有的提示信息
            let fontCount=1;
            for(let index=0;index<numbers.length;index++){
                let item=numbers[index];
                let tempTip={}; //临时提示信息
                tempTip.value=item;
                if(index == numbers.length - 1){
                    tempTip.style="bottom:0px;";
                    tipsArray.push(tempTip);
                }else if(index ==0){
                    tempTip.style="top:"+itemHeight*index+"px;";
                    tipsArray.push(tempTip);
                }else {
                    // 去掉最顶和最末的文字宽度
                    if((itemHeight*index-15*fontCount>0)&&(itemHeight*index<=height)){
                        tempTip.style="top:"+itemHeight*index+"px;";
                        fontCount=fontCount+1;
                        tipsArray.push(tempTip);
                    }
                }

            }
            return tipsArray;

        },
        // 根据数字自动保存有效位数
        significantDigit(value){
            if(value>=10000||value<=-1000){
                value=parseInt(value);
            }else if(value>=1000||value<=-1000){
                value=parseFloat(value).toFixed(1);
            }else if(value>=100||value<=-100){
                value=parseFloat(value).toFixed(2);
            }else {
                value=parseFloat(value).toFixed(3);
            }
            return value;
        },
        // 新的渐变算法，主要是分别定义红、橙、黄、绿、青、蓝、紫颜色值，渐变时，分从紫到蓝，蓝到青，青到绿，依此分段渐变，最后组成一个渐变色数组
        // 形成整个渐变色,比如从绿色渐变到红色，应先从绿色渐变到黄色，然后从黄色渐变到橙色，然后从橙色渐变到红色
        //     红: #FF0000  255，0，0
        //     橙: #FF7D00  255, 125, 0
        //     黄: #FFFF00  255，255，0
        //     绿: #00FF00  0，255，0
        //     青: #00FFFF  0, 255, 255
        //     蓝: #0000FF  0，0，255
        //     紫: #FF00FF  255, 0, 255

        /**
         * 色卡为一段时
         * 从紫色到红色
         */
        getRainbowColorArray(colorSize){
            let color_list=[];
            if(colorSize<6){
                switch (colorSize) {
                    case 1:
                        color_list=["rgb(255，0，0)"];
                        break;
                    case 2:
                        color_list=["rgb(255，0，0)","rgb(255, 0, 255)"];
                        break;
                    case 3:
                        color_list=["rgb(255，0，0)","rgb(0，255，0)","rgb(255, 0, 255)"];
                        break;
                    case 4:
                        color_list=["rgb(255，0，0)","rgb(255，255，0)","rgb(0，255，0)","rgb(0,255, 255)","rgb(255, 0, 255)"];
                        break;
                    case 5:
                        color_list=["rgb(255，0，0)","rgb(255，255，0)","rgb(0，255，0)","rgb(0,255, 255)","rgb(255, 0, 255)"];
                        break;
                    case 6:
                        color_list=["rgb(255，0，0)","rgb(255，255，0)","rgb(0，255，0)","rgb(0,255, 255)","rgb(0，0，255)","rgb(255, 0, 255)"];
                        break;
                    case 7:
                        color_list=["rgb(255，0，0)","rgb(255, 125, 0)","rgb(255，255，0)","rgb(0，255，0)","rgb(0,255, 255)","rgb(0，0，255)","rgb(255, 0, 255)"];
                        break;
                }
            }else {
                let subColorSieze=parseInt(colorSize/7);
                let subRemainder=colorSize%7;
                let color=["#FF0000","#FF7D00","#FFFF00","#00FF00","#00FFFF","#0000FF","#FF00FF","#FF0000"];
                color_list=this.getSubColor(color,subColorSieze,subRemainder);
            }
            // return color_list.reverse();
            return color_list;
        },
        /**
         * 色卡分为两段时
         * 渐变色第一段，从绿色到红色
         */
        getRainbowColor2Array_own(colorSize){
            let color_list=[];
            if(colorSize<5){
                switch (colorSize) {
                    case 1:
                        color_list=["rgb(255，0，0)"];
                        break;
                    case 2:
                        color_list=["rgb(255，0，0)","rgb(255, 125, 0)"];
                        break;
                    case 3:
                        color_list=["rgb(255，0，0)","rgb(255, 125, 0)","rgb(255，255，0)"];
                        break;
                    case 4:
                        color_list=["rgb(255，0，0)","rgb(255, 125, 0)","rgb(255，255，0)","rgb(0，255，0)"];
                        break;
                }
            }else {
                let subColorSieze=parseInt(colorSize/4);
                let subRemainder=colorSize%4;
                let color=["#FF0000","#FF7D00","#FFFF00","#00FF00","#00FFFF"];
                color_list=this.getSubColor(color,subColorSieze,subRemainder);
            }
            // return color_list.reverse();
            return color_list;
        },
         /**
         * 色卡分为两段时
         * 渐变色第二段，从青色到紫色
         */
        getRainbowColor2Array_two(colorSize){
            let color_list=[];
            if(colorSize<4){
                switch (colorSize) {
                    case 1:
                        color_list=["rgb(0, 255, 255)"];
                        break;
                    case 2:
                        color_list=["rgb(0, 255, 255)","rgb(0，0，255)"];
                        break;
                    case 3:
                        color_list=["rgb(0, 255, 255)","rgb(0，0，255)","rgb(255, 0, 255)"];
                        break;
                }
            }else {
                let subColorSieze=parseInt(colorSize/2);
                let subRemainder=colorSize%2;
                let color=["#00FFFF","#0000FF","#FF00FF"];
                color_list=this.getSubColor(color,subColorSieze,subRemainder);
            }
            // return color_list.reverse();
            return color_list;
        },
        /**
         * 获取子颜色段
         * colorArray 颜色数组
         * step 步长
         * remainder 剩余分段
         */
        getSubColor:function(colorArray,step,remainder){
            let colorCount=colorArray.length;
            let color_list=[];
            for(let i=0;i<colorCount-1;i++){
                let temp=0;
                if(remainder>0){
                    temp=1;
                }
                let tempArray=new GradientColor(colorArray[i],colorArray[i+1],step+temp);
                color_list.push.apply(color_list,tempArray);
                remainder--;
            }
            return color_list;
        },

        // 高精度加减乘除
        //除法
        accDiv:function (arg1, arg2) {
            var t1 = 0,
                t2 = 0,
                r1, r2;
            try {
                t1 = arg1.toString().split(".")[1].length
            } catch (e) {
                t1=0;
            }
            try {
                t2 = arg2.toString().split(".")[1].length
            } catch (e) {
                t2=0;
            }

            r1 = Number(arg1.toString().replace(".", ""))
            r2 = Number(arg2.toString().replace(".", ""))
            return (r1 / r2) * Math.pow(10, t2 - t1);
        },
        //乘法
        accMul:function (arg1, arg2) {
            var m = 0,
                s1 = arg1.toString(),
                s2 = arg2.toString();
            try {
                m += s1.split(".")[1].length
            } catch (e) {
                m=0;
            }
            try {
                m += s2.split(".")[1].length
            } catch (e) {
                m=0;
            }
            return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
        },
        //加法
        accAdd:function (arg1, arg2) {
            var r1, r2, m;
            try {
                r1 = arg1.toString().split(".")[1].length
            } catch (e) {
                r1 = 0
            }
            try {
                r2 = arg2.toString().split(".")[1].length
            } catch (e) {
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2))
            return (arg1 * m + arg2 * m) / m
        },
        //减法
        accSub:function (arg1, arg2) {
            var r1, r2, m, n;
            try {
                r1 = arg1.toString().split(".")[1].length
            } catch (e) {
                r1 = 0
            }
            try {
                r2 = arg2.toString().split(".")[1].length
            } catch (e) {
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2));
            n = (r1 >= r2) ? r1 : r2;
            return ((arg1 * m - arg2 * m) / m).toFixed(n);
        },
    }
}
</script>

<style lang="scss">
.colorcard{
    position: absolute;
    top: 11rem;
    right: 10px;
    color: #fff;

    .colorbar{
        margin-bottom: 10px;

        .colorbar-tip-wrap{
            position: relative;
            position: relative;
            width: 70px;
            top: 0px;
            height: 150px;
            background: rgba(0,0,0,0.4);
            display: inline-block;
        }
        .colorbar-item{
            display: inline-block;
            display: flex;
            flex-direction: row;
            width: 15px;
        }
        .colorbar-tip{
            display: flex;
            justify-content: flex-end;
            padding-right:4px;
            align-items: center;
            font-size: 12px;
            width: 70px;
            position: absolute;
        }
        .colorbar-colrr{
            height:100%;
            width:15px
        }

        .color-wrap{
            display: inline-block;
        }
    }
   
}   
</style>